import { createAsyncThunk } from '@reduxjs/toolkit';
import dashboardApi from '../../../api/dashboardApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'dashboard';

export const GetAverageDailyProductionCapacity = createAsyncThunk(
  `${REDUCER_NAME}/getAverageDailyProductionCapacity`,
  async (__, thunkAPI) => {
    const res = await dashboardApi.getAverageDailyProductionCapacity();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetTobaccosInStock = createAsyncThunk(`${REDUCER_NAME}/getTobaccosInStock`, async (__, thunkAPI) => {
  const res = await dashboardApi.getTobaccosInStock({});

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetTotalStats = createAsyncThunk<any, any>(`${REDUCER_NAME}/getTotalStats`, async (data, thunkAPI) => {
  const res = await dashboardApi.getTotalStats(data);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
